import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/custom-terms-templates';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['PUT'];
type Input = THIS_API['body'];
type Output = THIS_API['response'];

const updateOrCreateCustomTermsTemplate = async (body: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE);
  const data = await noodleApiClient.put(path, body);
  return data.data;
};

export default updateOrCreateCustomTermsTemplate;
